import type { ActionContext } from 'vuex'

import type { ActionClass, Dictionary, HighlightsSetup, HighlightsState } from '../../../models'

import { HIGHLIGHTS_CONSTS } from '../highlights.consts'

export class SetSetupAction implements ActionClass {
  static execute(
    this: void,
    { commit }: ActionContext<HighlightsState, any>,
    setup: Dictionary<HighlightsSetup>,
  ): void {
    commit(HIGHLIGHTS_CONSTS.mutations.setSetup, setup)
  }
}
